/* ============
 * Getters for the alert module
 * ============
 *
 * The getters that are available on the
 * alert module.
 */
import { clone } from '@/utils/object';

const getAlerts = state => clone(state.alerts);
const getTotalCount = state => clone(state.totalCount);
const getAlertCount = state => clone(state.alertCount);
const getAlert = state => clone(state.alert);
const getResolvedNotes = state => clone(state.resolvedNotes);
const getIsLoading = state => state.alertsLoading;
const getIsResolutionLoading = state => state.isResolutionLoading;
const getResolvedAlertId = state => state.resolvedAlertId;

export default {
  getAlerts,
  getTotalCount,
  getAlertCount,
  getAlert,
  getResolvedNotes,
  getIsLoading,
  getIsResolutionLoading,
  getResolvedAlertId
};
